// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3wnvW","info":"PatientInfo_info__i-qQe"};